const welderService = {
  title: "Welder",
  icon: "🔥",
  shortDescription:
    "Minor grill repair, welding support, frame correction, and small fabrication fixes.",
  longDescription:
    "Book welding support for repair, frame fixes, metal joint work, and small fabrication tasks. Large or custom fabrication work may require inspection.",
  consultationNote:
    "Heavy structural, site-specific, or custom fabrication jobs should begin with inspection.",
  responsePromise:
    "Assignment depends on work nature, safety, and equipment readiness.",
  warrantyPolicy:
    "Support depends on metal condition, design load, and job type.",
  subServices: [
    {
      id: "welder-grill-repair",
      title: "Grill Repair",
      icon: "🪟",
      group: "Repair",
      description:
        "Repair broken grill section, minor crack, loose joint, or damaged weld point.",
      basePrice: 699,
      priceType: "starts_at",
      duration: "1-3 hrs",
      warranty: "3 days",
      unit: "job",
    },
    {
      id: "welder-gate-joint-fix",
      title: "Gate Joint / Hinge Welding",
      icon: "🚪",
      group: "Repair",
      description:
        "Fix metal gate hinge, joint, support crack, or minor weld breakage.",
      basePrice: 699,
      priceType: "starts_at",
      duration: "1-3 hrs",
      warranty: "3 days",
      unit: "job",
    },
    {
      id: "welder-frame-correction",
      title: "Metal Frame Correction",
      icon: "🛠️",
      group: "Fabrication Support",
      description:
        "Correct or reinforce small metal frame section where possible.",
      basePrice: 899,
      priceType: "starts_at",
      duration: "2-4 hrs",
      warranty: "3 days",
      unit: "job",
    },
    {
      id: "welder-inspection",
      title: "Welding / Fabrication Inspection",
      icon: "🔍",
      group: "Inspection",
      description:
        "Inspection visit for custom welding work, grill replacement, or fabrication estimate.",
      basePrice: 399,
      priceType: "inspection",
      duration: "30-45 mins",
      warranty: "Inspection only",
      unit: "visit",
    },
  ],
};

export default welderService;